import * as tslib_1 from "tslib";
import { put, takeLatest, call, select, all } from 'redux-saga/effects';
import { MODAL_MOUNT, CHANGE_GALLERY_ID, changeGalleryContents, loadGalleries, loadHasWixAccount, changeFlowState, RETRY_LOAD_HAS_WIX_ACCOUNT, SUBMIT_FORM, loadPreview, loadEditAndPreviewLink, setInitialFormState, } from './actions';
import { request } from '../../xhr';
import { take } from '../../utils/fp';
import { FlowState } from './types';
import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import { getGalleryId } from './selectors';
import { getCurrentUser, getIsMobile } from '../../publicSession';
import { ALL_FOLDER_ID, SCRAPS_FOLDER_ID } from '@wix/da-url';
var fakeGalleries = [];
function getFakeGalleries() {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        var galleries = require('@wix/da-sample-data')
            .galleries;
        fakeGalleries = take(20, galleries);
    }
    return fakeGalleries;
}
var fakeGalleryContents = [];
function getFakeGalleryContents() {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        var deviations = require('@wix/da-sample-data')
            .deviationsByType.image;
        fakeGalleryContents = take(20, deviations);
    }
    return fakeGalleryContents;
}
function fetchGalleryContents(username, folderId) {
    var result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: 'gallection/contents',
                    params: {
                        username: username,
                        folderid: folderId,
                        type: 'gallery',
                        all_folder: folderId === ALL_FOLDER_ID,
                        scraps_folder: folderId === SCRAPS_FOLDER_ID,
                    },
                }, function () { return ({ results: getFakeGalleryContents(), estimatedTotal: 20 }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
function fetchHasWixAccount() {
    var result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: 'wix_portfolio/has_wix_account',
                }, function () { return ({ isExists: true }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
function fetchInitData() {
    var result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: 'wix_portfolio/init_modal',
                }, function () { return ({
                    socialLinks: [
                        {
                            id: 4,
                            value: 'www.facebook.com/incompleteninny',
                        },
                    ],
                    bio: 'I make bad art for my D&D campaigns',
                    isWixuserExists: false,
                    folders: getFakeGalleries(),
                    deviations: {
                        hasMore: true,
                        nextOffset: 10,
                        estimatedTotal: 24,
                        results: getFakeGalleryContents(),
                    },
                }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function handleModalMount(action) {
    var user, isMobile, initResult, folders, deviations, bio, socialLinks, hasWixAccount;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // Make sure we start on the preload state on mount, useful for retrying or remounting
            return [4 /*yield*/, put(changeFlowState(FlowState.PRELOAD))];
            case 1:
                // Make sure we start on the preload state on mount, useful for retrying or remounting
                _a.sent();
                return [4 /*yield*/, select(getCurrentUser)];
            case 2:
                user = _a.sent();
                return [4 /*yield*/, select(getIsMobile)];
            case 3:
                isMobile = _a.sent();
                return [4 /*yield*/, call(fetchInitData)];
            case 4:
                initResult = _a.sent();
                if (!(initResult === false)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(changeFlowState(FlowState.PRELOAD_ERROR))];
            case 5:
                _a.sent();
                return [3 /*break*/, 11];
            case 6:
                folders = initResult.folders, deviations = initResult.deviations, bio = initResult.bio, socialLinks = initResult.socialLinks, hasWixAccount = initResult.isWixuserExists;
                return [4 /*yield*/, all([
                        put(loadGalleries(folders)),
                        put(changeGalleryContents(deviations.results, deviations.estimatedTotal)),
                        put(setInitialFormState({
                            title: user.username,
                            biography: bio,
                            socialNetworkLinks: socialLinks.reduce(function (obj, networkLink) {
                                var _a;
                                return (tslib_1.__assign({}, obj, (_a = {}, _a[networkLink.id] = networkLink.value, _a)));
                            }, {}),
                        })),
                        put(loadHasWixAccount(hasWixAccount)),
                    ])];
            case 7:
                _a.sent();
                if (!isMobile) return [3 /*break*/, 9];
                return [4 /*yield*/, put(changeFlowState(FlowState.CALL_TO_ACTION))];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, put(changeFlowState(FlowState.TERMS))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [2 /*return*/];
        }
    });
}
export function handleRetryLoadHasWixAccount(action) {
    var result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(changeFlowState(FlowState.PRELOAD))];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(fetchHasWixAccount)];
            case 2:
                result = _a.sent();
                if (!(result === false)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(changeFlowState(FlowState.PRELOAD_ERROR))];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4: return [4 /*yield*/, put(loadHasWixAccount(result.isExists))];
            case 5:
                _a.sent();
                return [4 /*yield*/, put(changeFlowState(FlowState.TERMS))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
export function handleGalleryChange(action) {
    var user, galleryId, _a, results, estimatedTotal;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getCurrentUser)];
            case 1:
                user = _b.sent();
                galleryId = action.payload.galleryId;
                return [4 /*yield*/, call(fetchGalleryContents, user ? user.username : undefined, galleryId)];
            case 2:
                _a = _b.sent(), results = _a.results, estimatedTotal = _a.estimatedTotal;
                if (!(results.length > 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(changeGalleryContents(results, estimatedTotal))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
export function handleSubmitForm(action) {
    var formState, galleryId, socialNetworkLinks, createResult, editLinkResult;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formState = action.payload.formState;
                return [4 /*yield*/, select(getGalleryId)];
            case 1:
                galleryId = _a.sent();
                socialNetworkLinks = omitBy(formState.socialNetworkLinks, function (value) { return !value; });
                return [4 /*yield*/, put(changeFlowState(FlowState.LOADING))];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'wix_portfolio/create',
                        data: omitBy({
                            username: formState.title,
                            tagline: formState.description,
                            bio: formState.biography,
                            theme_id: formState.themeId,
                            folder_ids: [galleryId],
                            social_links: isEmpty(socialNetworkLinks)
                                ? undefined
                                : socialNetworkLinks,
                        }, function (value) { return !value; }),
                    }, function () { return ({
                        previewMagicLink: 'https://fr.wikipedia.org/wiki/Main_Page',
                    }); })];
            case 3:
                createResult = _a.sent();
                if (!(createResult === false || createResult.status === 'error')) return [3 /*break*/, 5];
                return [4 /*yield*/, put(changeFlowState(FlowState.SUBMIT_ERROR))];
            case 4:
                _a.sent();
                return [3 /*break*/, 10];
            case 5: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: 'wix_portfolio/get_edit_link',
                }, function () { return ({ editMagicLink: 'https://fr.wikipedia.org/wiki/Main_Page' }); })];
            case 6:
                editLinkResult = _a.sent();
                return [4 /*yield*/, put(loadPreview(createResult.previewMagicLink))];
            case 7:
                _a.sent();
                return [4 /*yield*/, put(changeFlowState(FlowState.COMPLETE))];
            case 8:
                _a.sent();
                return [4 /*yield*/, put(loadEditAndPreviewLink(editLinkResult.editMagicLink))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(MODAL_MOUNT, handleModalMount),
                    takeLatest(CHANGE_GALLERY_ID, handleGalleryChange),
                    takeLatest(RETRY_LOAD_HAS_WIX_ACCOUNT, handleRetryLoadHasWixAccount),
                    takeLatest(SUBMIT_FORM, handleSubmitForm),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map